import client from "./client";

const employeesApi = {
  list(params = {}) {
    return client.get("/employees", { params }).then((r) => r.data);
  },

  get(id) {
    return client.get(`/employees/${id}`).then((r) => r.data);
  },

  create(body) {
    return client.post("/employees", body).then((r) => r.data);
  },

  update(id, body) {
    return client.patch(`/employees/${id}`, body).then((r) => r.data);
  },

  updateEmploymentStatus(id, status) {
    return client.patch(`/employees/${id}/employment-status`, { employmentStatus: status }).then((r) => r.data);
  },

  assignClasses(id, classes) {
    return client.patch(`/employees/${id}/assign-classes`, { assignedClasses: classes }).then((r) => r.data);
  },

  assignSubjects(id, subjects) {
    return client.patch(`/employees/${id}/assign-subjects`, { subjects }).then((r) => r.data);
  },

  assignClassTeacher(id, className) {
    return client.patch(`/employees/${id}/assign-class-teacher`, { className }).then((r) => r.data);
  },

  removeClassTeacher(id) {
    return client.patch(`/employees/${id}/remove-class-teacher`).then((r) => r.data);
  },
};

export default employeesApi;
